// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignatureChoice_check__l5bcR {
  margin-bottom: 45px;
}
.SignatureChoice_check-methods__CG3ZG {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 104px;
}
.SignatureChoice_check-methods__CG3ZG > div:first-child {
  margin-right: 3px;
}
.SignatureChoice_check-methods__CG3ZG > div:last-child {
  margin-left: 3px;
}
.SignatureChoice_check-method__k5pcd {
  width: calc(50% - 3px);
  padding: 20px 12px;
  border-radius: 8px;
  border: 1px solid #d8d8ff;
  text-align: center;
  background: #fff;
  cursor: pointer;
}
.SignatureChoice_check-method__k5pcd.SignatureChoice_selected__mKZbi {
  background: #4343ff;
}
.SignatureChoice_check-method__k5pcd.SignatureChoice_selected__mKZbi p {
  color: #fff;
}
.SignatureChoice_check-method__k5pcd p {
  font-size: 16px;
  line-height: 28px;
}

.SignatureChoice_checkbox-label__lBMzF {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #00007a;
}

.SignatureChoice_link__mRj0C {
  display: contents;
}
.SignatureChoice_link__mRj0C a,
.SignatureChoice_link__mRj0C a:visited {
  text-decoration: underline;
  color: #00007a;
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/SignatureChoice/SignatureChoice.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;AAIF;AAFE;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;AAIJ;AAFI;EACE,iBAAA;AAIN;AADI;EACE,gBAAA;AAGN;AACE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AACJ;AACI;EACE,mBC5BK;AD6BX;AACM;EACE,WAAA;AACR;AAGI;EACE,eAAA;EACA,iBAAA;AADN;;AAOE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3CO;ADuCX;;AAQA;EACE,iBAAA;AALF;AAOE;;EAEE,0BAAA;EACA,cCrDO;ADgDX","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n.check {\n  margin-bottom: 45px;\n\n  &-methods {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    height: 104px;\n\n    > div:first-child{\n      margin-right: 3px;\n    }\n\n    > div:last-child{\n      margin-left: 3px;\n    }\n  }\n\n  &-method {\n    width: calc(50% - 3px);\n    padding: 20px 12px;\n    border-radius: 8px;\n    border: 1px solid colors.$primary2;\n    text-align: center;\n    background: #fff;\n    cursor: pointer;\n\n    &.selected {\n      background: colors.$primary4;\n\n      p {\n        color: #fff;\n      }\n    }\n\n    p {\n      font-size: 16px;\n      line-height: 28px;\n    }\n  }\n}\n\n.checkbox {\n  &-label {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n    color: colors.$primary8;\n  }\n}\n\n.link {\n  display: contents;\n\n  a,\n  a:visited {\n    text-decoration: underline;\n    color: colors.$primary8;\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"check": `SignatureChoice_check__l5bcR`,
	"check-methods": `SignatureChoice_check-methods__CG3ZG`,
	"check-method": `SignatureChoice_check-method__k5pcd`,
	"selected": `SignatureChoice_selected__mKZbi`,
	"checkbox-label": `SignatureChoice_checkbox-label__lBMzF`,
	"link": `SignatureChoice_link__mRj0C`
};
export default ___CSS_LOADER_EXPORT___;
